// extracted by mini-css-extract-plugin
module.exports = {"root":"Tag_root__dSjOa","tag":"Tag_tag__ZqQP_","pointer":"Tag_pointer___oD5u"};